import uk from '@/internationalization/trans/chefs/uk/uk.json';
export default {
  trans: uk,
};
